<script>
  import { onMount } from 'svelte';
  import TermsAndPrivacyAjax from '@ajax/terms_and_privacy';
  import Log from '@utils/log';

  import jQuery from 'jquery';

  export let mobile = false;
  export let location = 'default';

  export let mobileOffset = 80;
  export let desktopOffset = 30;
  export let displayAbsolute = false;

  const footerHeight = 19;

  let footerEl;
  let termsAndPrivacy = { terms_url: '', privacy_url: '' };

  let footerAdjust = () => {
    if (location !== 'default') {
      return;
    }

    const wrapperHeight = jQuery('#svelte').height();
    const windowHeight = jQuery(window).height();
    const footer = jQuery(footerEl);

    let offset = mobile ? mobileOffset : desktopOffset;

    if (!displayAbsolute && wrapperHeight < windowHeight) {
      footer.removeClass('absolute').addClass('fixed').css('bottom', offset).css('height', 'unset');
    } else {
      footer
        .removeClass('fixed')
        .addClass('absolute')
        .css('bottom', 'auto')
        .css('height', footerHeight + offset);
    }
  };

  onMount(async () => {
    footerAdjust();
    window.addEventListener('resize', footerAdjust);
    try {
      termsAndPrivacy = await TermsAndPrivacyAjax.get();
    } catch {
      Log.info(`Unable to load privacy & terms in frontend (page bottom, location: ${location})`, true);
    }
    return () => {
      window.removeEventListener('resize', footerAdjust);
    };
  });
</script>

<style style="text/scss" lang="scss">
  .footer {
    .footer-default {
      font-size: 14px;
      color: #999;

      a {
        text-decoration: underline;
        color: #999;
        font-size: 14px;

        &:hover {
          color: #666;
        }
      }

      span {
        padding-left: 10px;
        padding-right: 10px;
      }
    }

    .footer-home {
      color: #555;

      a {
        color: #555;

        &:hover {
          color: #333;
        }
      }
    }

    .footer-demo-template {
      color: #000;
      font-size: 12px;

      a {
        color: #000;
      }
    }

    .footer-tiktok-desktop {
      width: 230px;
      display: flex;
      font-size: 12px;
    }

    &.fixed {
      position: fixed;
      left: 50%;
      transform: translateX(-50%);
    }

    &.absolute {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .mobile {
    width: 100%;
    text-align: center;

    .footer-default {
      font-size: 12px;
    }
  }
</style>

<div bind:this={footerEl} class="footer" class:mobile={mobile}>
  <div class="footer-default footer-{location}">
    <a on:click={() => window.open(termsAndPrivacy.terms_url)} target="_blank" href={termsAndPrivacy.terms_url}
      >Terms of Service</a>
    <span>|</span>
    <a on:click={() => window.open(termsAndPrivacy.privacy_url)} target="_blank" href={termsAndPrivacy.privacy_url}
      >Privacy Policy</a>
  </div>
</div>
